// Copyright 2006-2011 Jim Radford <jim@greenfelt.net> and David Caldwell <david@greenfelt.net>

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, card=piles.card,
                              up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;
var lib = require('./lib'), rand=lib.rand;
var dom = require('./dom'), doc=dom.doc, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout;
var score = require('./score'), Stat = score.Stat;


class poker_hand {
    constructor(cards) {
        this.cards = cards;
        this.ofakind = this.ofa("rank");
        this.ofasuit = this.ofa("suit");
    }
    #straights = { "5,4,3,2,1":1,  "6,5,4,3,2":2,   "7,6,5,4,3":3,  "8,7,6,5,4":4, "9,8,7,6,5":5,
                   "10,9,8,7,6":6, "11,10,9,8,7":7, "12,11,10,9,8":8, "13,12,11,10,9":9, "13,12,11,10,1":10 };
    #order = { high_card:0, pair:1, two_pair:2, three_of_a_kind:3, straight:4, flush:5,
               full_house:6, four_of_a_kind:7, straight_flush:8, royal_straight_flush:9 };
    ofa(type) {
            var bytype = [];
            for (var i in this.cards) {
                var t = this.cards[i][type];
                bytype[t] = bytype[t] == undefined ? 1 : bytype[t]+1;
            }
            var ofa = [];
            for (var t in bytype) {
                var n = bytype[t];
                if (ofa[n] == undefined)
                    ofa[n] = [];
                ofa[n].push(t);
            }
            for (var n in ofa)
                if (ofa[n]) ofa[n].sort(function(A,B) { return parseInt(B) - parseInt(A); });
            return ofa;
    }
    type() { // assumes 5 cards
            switch (this.ofakind[1] ? this.ofakind[1].length : 0) {
            case 0: return "full_house";
            case 1: return this.ofakind[2].length == 2 ? "two_pair" : "four_of_a_kind";
            case 2: return "three_of_a_kind";
            case 3: return "pair";
            case 5: var st = this.#straights[this.ofakind[1]], fl = this.ofasuit[5];
                return !st && !fl ? "high_card" : st && !fl ? "straight" :
                    !st &&  fl ? "flush"     : st == 10 ? "royal_straight_flush" : "straight_flush";
            }
    }
    partial_type() {
            if (this.ofakind[1] && this.ofakind[1].length == 5) {
                var st = this.#straights[this.ofakind[1]], fl = this.ofasuit[5];
                return !st && !fl ? "high_card" : st && !fl ? "straight" :
                    !st &&  fl ? "flush"     : st == 10 ? "royal_straight_flush" : "straight_flush";
            }
            if (this.ofakind[3] && this.ofakind[3].length == 1)
                return this.ofakind[2] && this.ofakind[2].length == 1 ? "full_house" : "three_of_a_kind";
            if (this.ofakind[2]) return this.ofakind[2].length == 2 ? "two_pair" : "pair";
            if (this.ofakind[4]) return "four_of_a_kind";
            return "high_card";
    }
}

solitaire.dealwithit = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.get_stats_state = () => ({ state: undefined }); // Disable Undo. It breaks the game.
        this.grid = new Array(5);
        for (var r=1; r<=5; r++) {
            this.grid[r] = Array(5);
            for (var c=1; c<=5; c++)
                this.grid[r][c] = new this.grid_pile("grid"+r+c, this);
        }
        this.discard = [];
        for (var c=1; c<=2; c++)
            this.discard[c] = new this.grid_pile("discard"+c, this);
        this.deck = new pile("deck", this);
        this.play = new pile("play", this);

        this.create_deck(this.deck, this.play, 1);

        for (let [hand,score] of Object.entries(this.score_table))
            doc.id(`${hand}_score`).textContent = new String(score);

        // Hack. How do we do this on the iPad?
        this.score_time = new pile("score_time", this, false);
        this.score_time.accept = function() { return false; };
        doc.id("score_time").appendChild(doc(["table",["tbody",
                                              ["tr",["td","Score:"],["td",{id: "score", style: {width: "3em", "textAlign": "right"}}]],
                                              ["tr",["td","Time:"], ["td",{id: "timer", style: {width: "3em", "textAlign": "right"}}]]]]));
        if (!this.timer) this.timer = new Stat(doc.id("timer"), "timer", this.stats);
        if (!this._score) this._score = new Stat(doc.id("score"), "score", this.stats);
        this._score.set(0);

        this.deck.yoffset = 0;
        var me = this; delete this.deck.onclick; delete this.ui.deck_play; // The deal is controlled automatically
        this.deck.flip = function() {
            if (this.game.deal_timeout)
                this.game.deal_timeout = cancel_timeout(this.game.deal_timeout);
            if (this.game.is_complete()) return;
            this.turn();
            var countdown = function(delay, f) {
                me.timer.set(delay);
                if (delay == 0) f();
                else me.deal_timeout = timeout(1000, function() { countdown(delay-1, f) });
            };
            return countdown(10, function () { me.random_play() });
        }
    }
    grid_pile = class extends pile {
        can_drag() { return false; }
        accept(card) { return this.pile.length == 0; }
        xoffset = 0;
        yoffset = 0;
        onclick() {
                    if (this.pile.length == 0) {
                        this.game.push_state();
                        if (this.game.play.pile.length)
                            this.game.play.move_to_pile(this.game.play.top_index(), 1, this);
                    }
        }
        splice(start, n/*, card1, card12, ...*/) {
                    var ret = pile.prototype.splice.apply(this, arguments);
                    this.game.deck.flip();
                    this.game.compute_score();
                    return ret;
        }
    }

    deal(deck) {
            if (this.overlay) this.overlay.unoverlay();
            this.overlay = overlay_card(deck[deck.length-27+Math.floor(rand()%27)], "star");
            this.deck.pile = deck;
            this.redraw(); // Hack. Do this early because deck.flip() calls animate_to() which expects cards.coords and that doesn't get set till we cards.draw() at least once.
            this.deck.flip();
    }

    won_message = "Game over!";

    random_play() {
            var left = [];
            if (this.discard[1].pile.left == 0) left.push(this.discard[1]);
            if (this.discard[2].pile.left == 0) left.push(this.discard[2]);
            for (var r in this.grid)
                for (var c in this.grid[r])
                    if (this.grid[r][c].pile.length == 0)
                        left.push(this.grid[r][c]);
            left[Math.floor(rand() % left.length)].onclick();
    }

    hands() {
            var hands = [];
            hands["diag"+1] = []; hands["diag"+2] = [];
            for (var i=1; i<=5; i++)
            { hands["row"+i] = []; hands["col"+i] = []; }
            for (var i=1; i<=5; i++)
                for (var j=1; j<=5; j++)
                    if (this.grid[i][j].pile.length) {
                        hands["row"+i].push(this.grid[i][j].pile[0]);
                        hands["col"+j].push(this.grid[i][j].pile[0]);
                        if (i ==   j) hands["diag"+1].push(this.grid[i][j].pile[0]);
                        if (i == 6-j) hands["diag"+2].push(this.grid[i][j].pile[0]);
                    }
            return hands;
    }

    is_complete() {
            for (var r in this.grid) for (var c in this.grid[r]) if (this.grid[r][c].pile.length == 0) return NOT_COMPLETE; return GAME_OVER;
    }

    score_table = { high_card: 0, pair: 10, two_pair:30, three_of_a_kind: 60, straight: 120, flush: 50,
                    full_house: 100, four_of_a_kind: 160, straight_flush: 300, royal_straight_flush: 450 };

    score() {
                var hands = this.hands();
                var score = 0;
                for (var h in hands) {
                    if (hands[h].length > 0) {
                        var scale = 1;
                        for (var i in hands[h])
                            if (hands[h][i] == this.overlay)
                                scale = 2;
                        var hand = new poker_hand(hands[h]);
                        score += scale * this.score_table[hand.partial_type()];
                    }
                }
                return score;
    }

    compute_score() {
            this._score.set(this.score());
    }

    layout = grid(["deck",       undefined, "grid11", "grid12", "grid13", "grid14", "grid15"],
                  ["play",       undefined, "grid21", "grid22", "grid23", "grid24", "grid25"],
                  ["score_time", undefined, "grid31", "grid32", "grid33", "grid34", "grid35"],
                  ["discard1",   undefined, "grid41", "grid42", "grid43", "grid44", "grid45"],
                  ["discard2",   undefined, "grid51", "grid52", "grid53", "grid54", "grid55"])
}

function overlay_card(orig, string) {
    orig.ui.draw = function(pile_ui, coords, z, animate) {
        var img = orig.ui.constructor.prototype.draw.call(this, pile_ui, coords, z, animate);
        if (orig.face == up)
            orig.overlay.ui.draw(pile_ui, coords, z);
        else
            orig.overlay.ui.erase();
    }
    orig.ui.erase = function() {
        orig.overlay.ui.erase();
        orig.ui.constructor.prototype.erase.call(this);
    }
    orig.unoverlay = function () {
        orig.overlay.ui.erase();
        delete orig.ui.draw;
        delete orig.ui.erase;
        delete orig.overlay;
        delete orig.unoverlay;
    }
    orig.overlay = new card(string,undefined,undefined,up,null,orig.ui.game);
    return orig;
};

module.exports = solitaire.dealwithit;
// Copyright 2006-2011 Jim Radford <jim@greenfelt.net> and David Caldwell <david@greenfelt.net>

var solitaire = require('./solitaire').games;
var piles = require('./piles'), pile_game=piles.pile_game, pile=piles.pile, card=piles.card,
                              up=piles.up;
var piles_ui = require('./piles-ui'), grid = piles_ui.grid;
var seed_game = require('./seed_game'), NOT_COMPLETE=seed_game.NOT_COMPLETE, GAME_OVER=seed_game.GAME_OVER;
var lib = require('./lib'), rand=lib.rand;
var dom = require('./dom'), doc=dom.doc, timeout=dom.timeout, cancel_timeout=dom.cancel_timeout;
var score = require('./score'), Stat = score.Stat;


class poker_hand {
    constructor(cards) {
        this.cards = cards;
        this.ofakind = this.ofa("rank");
        this.ofasuit = this.ofa("suit");
    }
    #straights = { "5,4,3,2,1":1,  "6,5,4,3,2":2,   "7,6,5,4,3":3,  "8,7,6,5,4":4, "9,8,7,6,5":5,
                   "10,9,8,7,6":6, "11,10,9,8,7":7, "12,11,10,9,8":8, "13,12,11,10,9":9, "13,12,11,10,1":10 };
    #order = { high_card:0, pair:1, two_pair:2, three_of_a_kind:3, straight:4, flush:5,
               full_house:6, four_of_a_kind:7, straight_flush:8, royal_straight_flush:9 };
    ofa(type) {
            var bytype = [];
            for (var i in this.cards) {
                var t = this.cards[i][type];
                bytype[t] = bytype[t] == undefined ? 1 : bytype[t]+1;
            }
            var ofa = [];
            for (var t in bytype) {
                var n = bytype[t];
                if (ofa[n] == undefined)
                    ofa[n] = [];
                ofa[n].push(t);
            }
            for (var n in ofa)
                if (ofa[n]) ofa[n].sort(function(A,B) { return parseInt(B) - parseInt(A); });
            return ofa;
    }
    type() { // assumes 5 cards
            switch (this.ofakind[1] ? this.ofakind[1].length : 0) {
            case 0: return "full_house";
            case 1: return this.ofakind[2].length == 2 ? "two_pair" : "four_of_a_kind";
            case 2: return "three_of_a_kind";
            case 3: return "pair";
            case 5: var st = this.#straights[this.ofakind[1]], fl = this.ofasuit[5];
                return !st && !fl ? "high_card" : st && !fl ? "straight" :
                    !st &&  fl ? "flush"     : st == 10 ? "royal_straight_flush" : "straight_flush";
            }
    }
    partial_type() {
            if (this.ofakind[1] && this.ofakind[1].length == 5) {
                var st = this.#straights[this.ofakind[1]], fl = this.ofasuit[5];
                return !st && !fl ? "high_card" : st && !fl ? "straight" :
                    !st &&  fl ? "flush"     : st == 10 ? "royal_straight_flush" : "straight_flush";
            }
            if (this.ofakind[3] && this.ofakind[3].length == 1)
                return this.ofakind[2] && this.ofakind[2].length == 1 ? "full_house" : "three_of_a_kind";
            if (this.ofakind[2]) return this.ofakind[2].length == 2 ? "two_pair" : "pair";
            if (this.ofakind[4]) return "four_of_a_kind";
            return "high_card";
    }
}

solitaire.dealwithit = class extends pile_game {
    constructor() {
        super();
        this.pile_game_init(...arguments);
        this.get_stats_state = () => ({ state: undefined }); // Disable Undo. It breaks the game.
        this.grid = new Array(5);
        for (var r=1; r<=5; r++) {
            this.grid[r] = Array(5);
            for (var c=1; c<=5; c++)
                this.grid[r][c] = new this.grid_pile("grid"+r+c, this);
        }
        this.discard = [];
        for (var c=1; c<=2; c++)
            this.discard[c] = new this.grid_pile("discard"+c, this);
        this.deck = new pile("deck", this);
        this.play = new pile("play", this);

        this.create_deck(this.deck, this.play, 1);

        for (let [hand,score] of Object.entries(this.score_table))
            doc.id(`${hand}_score`).textContent = new String(score);

        // Hack. How do we do this on the iPad?
        this.score_time = new pile("score_time", this, false);
        this.score_time.accept = function() { return false; };
        doc.id("score_time").appendChild(doc(["table",["tbody",
                                              ["tr",["td","Score:"],["td",{id: "score", style: {width: "3em", "textAlign": "right"}}]],
                                              ["tr",["td","Time:"], ["td",{id: "timer", style: {width: "3em", "textAlign": "right"}}]]]]));
        if (!this.timer) this.timer = new Stat(doc.id("timer"), "timer", this.stats);
        if (!this._score) this._score = new Stat(doc.id("score"), "score", this.stats);
        this._score.set(0);

        this.deck.yoffset = 0;
        var me = this; delete this.deck.onclick; delete this.ui.deck_play; // The deal is controlled automatically
        this.deck.flip = function() {
            if (this.game.deal_timeout)
                this.game.deal_timeout = cancel_timeout(this.game.deal_timeout);
            if (this.game.is_complete()) return;
            this.turn();
            var countdown = function(delay, f) {
                me.timer.set(delay);
                if (delay == 0) f();
                else me.deal_timeout = timeout(1000, function() { countdown(delay-1, f) });
            };
            return countdown(10, function () { me.random_play() });
        }
    }
    grid_pile = class extends pile {
        can_drag() { return false; }
        accept(card) { return this.pile.length == 0; }
        xoffset = 0;
        yoffset = 0;
        onclick() {
                    if (this.pile.length == 0) {
                        this.game.push_state();
                        if (this.game.play.pile.length)
                            this.game.play.move_to_pile(this.game.play.top_index(), 1, this);
                    }
        }
        splice(start, n/*, card1, card12, ...*/) {
                    var ret = pile.prototype.splice.apply(this, arguments);
                    this.game.deck.flip();
                    this.game.compute_score();
                    return ret;
        }
    }

    deal(deck) {
            if (this.overlay) this.overlay.unoverlay();
            this.overlay = overlay_card(deck[deck.length-27+Math.floor(rand()%27)], "star");
            this.deck.pile = deck;
            this.redraw(); // Hack. Do this early because deck.flip() calls animate_to() which expects cards.coords and that doesn't get set till we cards.draw() at least once.
            this.deck.flip();
    }

    won_message = "Game over!";

    random_play() {
            var left = [];
            if (this.discard[1].pile.left == 0) left.push(this.discard[1]);
            if (this.discard[2].pile.left == 0) left.push(this.discard[2]);
            for (var r in this.grid)
                for (var c in this.grid[r])
                    if (this.grid[r][c].pile.length == 0)
                        left.push(this.grid[r][c]);
            left[Math.floor(rand() % left.length)].onclick();
    }

    hands() {
            var hands = [];
            hands["diag"+1] = []; hands["diag"+2] = [];
            for (var i=1; i<=5; i++)
            { hands["row"+i] = []; hands["col"+i] = []; }
            for (var i=1; i<=5; i++)
                for (var j=1; j<=5; j++)
                    if (this.grid[i][j].pile.length) {
                        hands["row"+i].push(this.grid[i][j].pile[0]);
                        hands["col"+j].push(this.grid[i][j].pile[0]);
                        if (i ==   j) hands["diag"+1].push(this.grid[i][j].pile[0]);
                        if (i == 6-j) hands["diag"+2].push(this.grid[i][j].pile[0]);
                    }
            return hands;
    }

    is_complete() {
            for (var r in this.grid) for (var c in this.grid[r]) if (this.grid[r][c].pile.length == 0) return NOT_COMPLETE; return GAME_OVER;
    }

    score_table = { high_card: 0, pair: 10, two_pair:30, three_of_a_kind: 60, straight: 120, flush: 50,
                    full_house: 100, four_of_a_kind: 160, straight_flush: 300, royal_straight_flush: 450 };

    score() {
                var hands = this.hands();
                var score = 0;
                for (var h in hands) {
                    if (hands[h].length > 0) {
                        var scale = 1;
                        for (var i in hands[h])
                            if (hands[h][i] == this.overlay)
                                scale = 2;
                        var hand = new poker_hand(hands[h]);
                        score += scale * this.score_table[hand.partial_type()];
                    }
                }
                return score;
    }

    compute_score() {
            this._score.set(this.score());
    }

    layout = grid(["deck",       undefined, "grid11", "grid12", "grid13", "grid14", "grid15"],
                  ["play",       undefined, "grid21", "grid22", "grid23", "grid24", "grid25"],
                  ["score_time", undefined, "grid31", "grid32", "grid33", "grid34", "grid35"],
                  ["discard1",   undefined, "grid41", "grid42", "grid43", "grid44", "grid45"],
                  ["discard2",   undefined, "grid51", "grid52", "grid53", "grid54", "grid55"])
}

function overlay_card(orig, string) {
    orig.ui.draw = function(pile_ui, coords, z, animate) {
        var img = orig.ui.constructor.prototype.draw.call(this, pile_ui, coords, z, animate);
        if (orig.face == up)
            orig.overlay.ui.draw(pile_ui, coords, z);
        else
            orig.overlay.ui.erase();
    }
    orig.ui.erase = function() {
        orig.overlay.ui.erase();
        orig.ui.constructor.prototype.erase.call(this);
    }
    orig.unoverlay = function () {
        orig.overlay.ui.erase();
        delete orig.ui.draw;
        delete orig.ui.erase;
        delete orig.overlay;
        delete orig.unoverlay;
    }
    orig.overlay = new card(string,undefined,undefined,up,null,orig.ui.game);
    return orig;
};

module.exports = solitaire.dealwithit;
